export default "__VITE_ASSET__CCV2rgjs__"